import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage/session";
import { commonReducer } from "../modules/common";
import { configurationReducer } from "../modules/configuration";
import { languageReducer } from "../modules/language";
import { notificationReducer } from "../modules/notification";
import { surgeryReducer } from "../modules/surgery";

const applicationReducers = {
  common: commonReducer,
  configuration: configurationReducer,
  language: languageReducer,
  notification: notificationReducer,
  surgery: surgeryReducer,
};

export const createReducers = (whitelist) => {
  const persistConfig = {
    key: "root",
    storage,
    whitelist: whitelist,
  };
  const allReducers = combineReducers({ ...applicationReducers });
  return persistReducer(persistConfig, allReducers);
};
